export default __webpack_public_path__ + "static/media/img_main.3d4a4e4b.png";